export default __webpack_public_path__ + "static/artifakt-legend-regular-e6008f6ff418063747e04d6a731519f8.woff2";